import { useTranslation } from '../../i18n/useTranslation';
import styles from './MissionPortalBanner.module.css';

// ─────────────────────────────────────────────────────────────────────────────
// Banner do nível vencido: o jogador continua vendo o mapa e o portal que
// acabou de surgir (célula injetada na grade pelo App). É preciso ir até o
// portal: longe → "Ir até o portal" (anda e entra); ao lado → "Entrar".
// Quem caiu (equipe) só espera um aliado entrar. Ao entrar o banner some e a
// grade escurece até o portal (CombatGrid `portalWarp` + .portalBlackout no App).
// ─────────────────────────────────────────────────────────────────────────────

interface Props {
  /** Nível 0-based que acabou de ser vencido. */
  level: number;
  entering: boolean;
  error: string | null;
  /** Está no portal ou numa casa vizinha. */
  near: boolean;
  /** De pé (quem caiu não anda; segue quando um aliado entrar). */
  canWalk: boolean;
  /** Andando até o portal (entra ao chegar). */
  walking: boolean;
  onEnter: () => void;
}

export default function MissionPortalBanner({ level, entering, error, near, canWalk, walking, onEnter }: Props) {
  const { t } = useTranslation();

  return (
    <>
      {/* Explosão de luz quando o portal se abre (só no surgimento) */}
      <div className={styles.burst} aria-hidden="true" />

      <div className={`${styles.banner} ${entering ? styles.leaving : ''}`} role="status">
        <span className={styles.icon}>🌀</span>
        <div className={styles.text}>
          <strong>{t('mission.result.levelDone').replace('{n}', String(level + 1))}</strong>
          <span>{canWalk ? t('mission.result.enterHint') : t('mission.result.waitAlly')}</span>
          {error && <span className={styles.error}>{error}</span>}
        </div>
        {canWalk && (
          <button className={styles.btn} onClick={onEnter} disabled={entering || walking}>
            {entering || walking ? '…' : near ? t('mission.result.enterPortal') : t('mission.result.goToPortal')}
          </button>
        )}
      </div>

    </>
  );
}
